export const DOCUMENT_REGLEMENTAIRE = {
    SET_ITEMS: 'SET_DOCUMENT_REGLEMENTAIRE_ITEMS',
    ADD_ITEMS: 'ADD_DOCUMENT_REGLEMENTAIRE_ITEMS',
    SET_ITEMS_ADR: 'SET_ADR_ITEMS',
    ADD_ITEMS_ADR: 'ADD_ADR_ITEMS',
    SET_ITEMS_PEC: 'SET_PEC_ITEMS',
    RESET_ITEMS: 'DOCUMENT_REGLEMENTAIRE_RESET_ITEMS',

    SET_PAGE: 'SET_DOCUMENT_REGLEMENTAIRE_PAGE',
    SET_NB_OF_PAGES: 'SET_DOCUMENT_REGLEMENTAIRE_NB_OF_PAGES',
    SET_SCROLL: 'SET_DOCUMENT_REGLEMENTAIRE_SCROLL',

    SET_FILTER_SITE: 'SET_DOCUMENT_REGLEMENTAIRE_FILTER_SITE',
    SET_FILTER_GROUPE: 'SET_DOCUMENT_REGLEMENTAIRE_FILTER_GROUPE',
    SET_FILTER_SOUS_GROUPE: 'SET_DOCUMENT_REGLEMENTAIRE_FILTER_SOUS_GROUPE',
    SET_FILTER_EQUIPEMENT: 'SET_DOCUMENT_REGLEMENTAIRE_FILTER_EQUIPEMENT',
    ADD_FILTER_SITE: 'ADD_DOCUMENT_REGLEMENTAIRE_FILTER_SITE',
    REMOVE_FILTER_SITE: 'REMOVE_DOCUMENT_REGLEMENTAIRE_FILTER_SITE',
    SET_FILTER_DOCUMENT_TYPE: 'SET_DOCUMENT_REGLEMENTAIRE_FILTER_DOCUMENT_TYPE',
    SET_FILTER_DOCUMENT_DATE_FROM: 'SET_DOCUMENT_REGLEMENTAIRE_FILTER_DOCUMENT_DATE_FROM',
    SET_FILTER_DOCUMENT_DATE_TO: 'SET_DOCUMENT_REGLEMENTAIRE_FILTER_DOCUMENT_DATE_TO',

    SET_SORT: 'SET_DOCUMENT_REGLEMENTAIRE_SORT',
    SET_SORT_ADR: 'SET_DOCUMENT_REGLEMENTAIRE_SORT_ADR',
    SET_COUNT: 'SET_DOCUMENT_REGLEMENTAIRE_COUNT',
    SET_COUNT_FOR_MODAL: 'SET_COUNT_FOR_MODAL',

    SET_ERROR: 'SET_DOCUMENT_REGLEMENTAIRE_ERROR',
    SET_IS_LOADING: 'SET_DOCUMENT_REGLEMENTAIRE_IS_LOADING',
    SET_ZIP_IS_LOADING: 'SET_ZIP_IS_LOADING',

    RESET: 'RESET_DOCUMENT_REGLEMENTAIRE',

    SET_TYPES_DOCUMENTS: 'SET_TYPES_DOCUMENTS'
};
